<template>
    <cic-popup
        :title="profile.profileId ? 'Edit Object Profile' : 'New Object Profile'"
        :saveable="editing"
        class="edit-object-profile"
        @blur="$emit('blur')"
        @input="$emit('input')"
    >
        <div class="item-form">
            <ul>
                <li class="form-label-first">
                    {{ $t('Name') }}
                </li>
                <li>
                    <cic-textbox
                        id="profile_name"
                        :value="profile.name"
                        :enabled="editing"
                        :maxlength="nameLength"
                        @input="(val) => updateFieldValue('name', val)"
                    />
                </li>
            </ul>
        </div>
        <div id="objects_view">
            <div id="divObjectTypes">
                <ul>
                    <li
                        v-for="(categoryTypes, category) in types"
                        :class="{ selected: selected.includes(category) }"
                        class="categoryOption"
                    >
                        <div @click="selectCategory(category)">
                            <div class="optionLabel" style="display: inline-block">
                                {{ $t(category) }}
                            </div>
                            <span></span>
                        </div>
                        <ul v-if="selected.includes(category)">
                            <li
                                v-for="type in categoryTypes"
                                :id="'label_' + type.type"
                                :class="{ selected: selectedOption === type.type }"
                                class="objectTypeOption"
                                @click="selectOption(category, type.type)"
                            >
                                <div class="optionLabel">
                                    {{ $t(type.label) }}
                                </div>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div id="divObjects">
                <template v-for="(categoryTypes, category) in types">
                    <template v-for="type in categoryTypes">
                        <div
                            v-if="selectedOption === type.type"
                            :id="'objects_' + type.type"
                            :class="{ loading: !Object.keys(profile.loaded).includes(type.type) }"
                        >
                            <template v-if="Object.keys(profile.loaded).includes(type.type)">
                                <edit-cks-objects
                                    v-if="category === 'CKS'"
                                    :enabled="editing"
                                    :field-access="profile.loaded[type.type].fieldAccess"
                                    :fields="profile.loaded[type.type].fields"
                                    :filters="profile.loaded[type.type].filters"
                                    :forms="profile.loaded[type.type].forms"
                                    :form-id="profile.loaded[type.type].formId"
                                    @input="updateValue"
                                />
                                <edit-objects
                                    v-else
                                    :value="profile.loaded[type.type].value"
                                    :enabled="editing"
                                    :type="type"
                                    @input="(val) => updateValue('value', val)"
                                />
                            </template>
                        </div>
                    </template>
                </template>
            </div>
        </div>
    </cic-popup>
</template>

<script>
    import CicPopup from '@/components/CicPopup';
    import CicTextbox from '@/components/inputs/CicTextbox';
    import EditCksObjects from './EditCksObjects';
    import EditObjects from './EditObjects';

    export default {
        name: 'EditObjectProfile',
        components: {
            CicPopup,
            CicTextbox,
            EditCksObjects,
            EditObjects,
        },
        props: {
            nameLength: {
                type: Number,
                default: 32,
            },
            profile: {
                type: Object,
                required: true,
            },
            types: {
                type: Object,
                required: true,
            },
        },
        emits: ['blur', 'change', 'input', 'loadObjects'],
        data() {
            return {
                selected: [],
                selectedOption: null,
            };
        },
        computed: {
            editing() {
                return (
                    this.profile &&
                    ((this.profile.profileId && this.$store.hasRight('EDIT_OBJECT_PROFILES')) ||
                        (!this.profile.profileId && this.$store.hasRight('ADD_OBJECT_PROFILES')))
                );
            },
        },
        methods: {
            selectCategory(category) {
                if (this.selected.includes(category)) {
                    this.selected.splice(this.selected.indexOf(category), 1);
                } else {
                    this.selected.push(category);
                }
            },

            selectOption(category, type) {
                this.selectedOption = type;
                if (!Object.keys(this.profile.loaded).includes(type)) {
                    this.$emit('loadObjects', category, type);
                }
            },

            updateFieldValue(field, value) {
                this.$emit('change', field, value);
            },

            updateValue(field, val) {
                const loaded = JSON.parse(JSON.stringify(this.profile.loaded));
                loaded[this.selectedOption][field] = val;
                this.updateFieldValue('loaded', loaded);
            },
        },
    };
</script>
